import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  standalone: true,
  selector: 'nggt-search-input',
  styleUrls: ['./search-input.component.scss'],
  template: `
    <i class="control-icon ion ion-ios-search" (click)="showInput()"></i>
    <input
      placeholder="Type your search request here..."
      #input
      [class.hidden]="!isInputShown"
      (blur)="hideInput()"
      (input)="onInput($event)"
    />
  `,
})
export class SearchInputComponent {
  @ViewChild('input', { static: true }) input?: ElementRef;

  // Not `search`: that is a native input event name, so a listener bound to it would
  // also fire on the DOM event (@angular-eslint/no-output-native).
  @Output() readonly searchChange: EventEmitter<string> = new EventEmitter<string>();

  isInputShown = false;

  showInput() {
    this.isInputShown = true;
    this.input?.nativeElement.focus();
  }

  hideInput() {
    this.isInputShown = false;
  }

  onInput(val: Event | string) {
    if (typeof val === 'string') {
      this.searchChange.emit(val);
    } else {
      this.searchChange.emit((val.target as HTMLInputElement).value);
    }
  }
}
